import React from "react";
import MuiTextField from "@mui/material/TextField";
import { textFieldProps } from "./fieldProps";

/** `textarea` — several lines; `maxLength` enforced by the input. */
export default function TextArea(props) {
	return <MuiTextField {...textFieldProps(props)} multiline minRows={3} maxRows={8} inputProps={{ maxLength: props.field.maxLength }} />;
}
